var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("el-tabs", {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "会员收费设置",
      name: "first"
    }
  }, [_c("MemberRechargePosition")], 1), _c("el-tab-pane", {
    attrs: {
      label: "红娘收费设置",
      name: "matchmaker"
    }
  }, [_c("MatchmakerRechargePosition")], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };